import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useT } from "@/context/ContentContext";

export default function HomeCtaFinal() {
    const { settings } = useSettings();
    const t = useT();
    return (
        <section className="pb-16 sm:pb-24">
            <div className="max-w-[1400px] mx-auto px-3 sm:px-4">
                <div className="bg-[hsl(var(--forest))] rounded-[2rem] p-10 sm:p-16 text-center text-white">
                    <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-3xl mx-auto">
                        {t("home.cta.title", "Tem uma obra em mente?")}
                    </h2>
                    <p className="text-white/80 text-lg mt-6 max-w-2xl mx-auto">
                        {t("home.cta.subtitle", "Conte-nos o que pretende fazer. Começamos por perceber a obra antes de lhe dizer como a devemos fazer — e, a partir daí, acompanha cada passo.")}
                    </p>
                    <div className="flex flex-wrap gap-3 justify-center mt-10">
                        <a href={`tel:${settings.phone.replace(/\s/g,'')}`} className="btn-outline-dark" data-testid="cta-call-btn">
                            {t("home.cta.button_call", "Ligar agora")}
                            <span className="arrow-circle"><Phone className="w-3.5 h-3.5" /></span>
                        </a>
                        <Link to="/orcamento" data-testid="cta-orcamento-btn" className="btn-copper">
                            {t("home.cta.button", "Pedir orçamento")}
                            <span className="arrow-circle"><ArrowUpRight className="w-3.5 h-3.5" /></span>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
